import validarCPF from '@/validators/validarCPF';
import validarDataValidadeCartao from '@/validators/validarDataValidadeCartao';
import validarNumeroCartao from '@/validators/validarNumeroCartao';
import * as Yup from 'yup';
import { TipoPagamentoID } from '../types/tipoPagamentoEnum';

export const schemaNovoPedidoRequest: Yup.Schema = Yup.object().shape({
  nome: Yup.string().when(['cartaoID', 'tipoPagamentoID'], {
    is: (cartaoID: string, tipoPagamentoID: string) =>
      !!cartaoID || tipoPagamentoID === TipoPagamentoID.pix,
    then: (schema) => schema.notRequired(),
    otherwise: (schema) => schema.required(),
  }),
  nomeCompleto: Yup.string().when(['cartaoID', 'tipoPagamentoID'], {
    is: (cartaoID: string, tipoPagamentoID: string) =>
      !!cartaoID || tipoPagamentoID === TipoPagamentoID.pix,
    then: (schema) => schema.notRequired(),
    otherwise: (schema) => schema.required(),
  }),
  cpf: Yup.string()
    .when('tipoPagamentoID', {
      is: (tipoPagamentoID: string) => tipoPagamentoID === TipoPagamentoID.pix,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.required('O CPF é obrigatório'),
    })
    .test('cpf-valido', 'CPF inválido', (value) => {
      if (!value) return true;
      return validarCPF(value);
    }),
  email: Yup.string().when(['cartaoID', 'tipoPagamentoID'], {
    is: (cartaoID: string, tipoPagamentoID: string) =>
      !!cartaoID || tipoPagamentoID === TipoPagamentoID.pix,
    then: (schema) => schema.notRequired(),
    otherwise: (schema) =>
      schema.email('Email inválido').required('O email é obrigatório'),
  }),
  bandeira: Yup.string().when(['cartaoID', 'tipoPagamentoID'], {
    is: (cartaoID: string, tipoPagamentoID: string) =>
      !!cartaoID || tipoPagamentoID === TipoPagamentoID.pix,
    then: (schema) => schema.notRequired(),
    otherwise: (schema) => schema.required(),
  }),
  apresentar: Yup.boolean().when(['cartaoID', 'tipoPagamentoID'], {
    is: (cartaoID: string, tipoPagamentoID: string) =>
      !!cartaoID || tipoPagamentoID === TipoPagamentoID.pix,
    then: (schema) => schema.notRequired(),
    otherwise: (schema) => schema.required(),
  }),
  numero: Yup.string().when(['cartaoID', 'tipoPagamentoID'], {
    is: (cartaoID: string, tipoPagamentoID: string) =>
      !!cartaoID || tipoPagamentoID === TipoPagamentoID.pix,
    then: (schema) => schema.notRequired(),
    otherwise: (schema) =>
      schema
        .required('O numero do cartão é obrigatório')
        .test('cartao-numero-valido', 'Numero cartão inválido', (value) => {
          if (!value) return false;
          return validarNumeroCartao(value);
        }),
  }),
  codigoVerificador: Yup.string().when(['cartaoID', 'tipoPagamentoID'], {
    is: (cartaoID: string, tipoPagamentoID: string) =>
      !!cartaoID || tipoPagamentoID === TipoPagamentoID.pix,
    then: (schema) => schema.notRequired(),
    otherwise: (schema) =>
      schema
        .matches(/^\d{3,4}$/, 'O código verificador deve ter 3 ou 4 dígitos')
        .required('O código verificador é obrigatório'),
  }),
  dataVencimento: Yup.string().when(['cartaoID', 'tipoPagamentoID'], {
    is: (cartaoID: string, tipoPagamentoID: string) =>
      !!cartaoID || tipoPagamentoID === TipoPagamentoID.pix,
    then: (schema) => schema.notRequired(),
    otherwise: (schema) =>
      schema
        .required('A data de validade do cartão é obrigatório')
        .test(
          'validade-cartao-valido',
          'Data de validade do cartão inválida',
          (value) => {
            if (!value) return false;
            return validarDataValidadeCartao(value);
          },
        ),
  }),
  planoID: Yup.array()
    .of(Yup.object().shape({ id: Yup.string() }))
    .notRequired(),
  comboID: Yup.array()
    .of(Yup.object().shape({ id: Yup.string() }))
    .notRequired(),
  comboPlanoID: Yup.array()
    .of(Yup.object().shape({ id: Yup.string() }))
    .notRequired(),
  pedidoID: Yup.string().notRequired(),
  cartaoID: Yup.string().notRequired(),
  tipoPagamentoID: Yup.string().required(),
});
